export default "__VITE_ASSET__CI2AuIKA__"